/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".small[_ngcontent-%COMP%]{width:100px}.medium[_ngcontent-%COMP%]{width:180px}fieldset[_ngcontent-%COMP%]{border:0}.level-fieldset[_ngcontent-%COMP%]{margin-top:-15.6px}.loginError[_ngcontent-%COMP%]{padding:16px;width:300px;color:#fff;background-color:#f44336}.legend[_ngcontent-%COMP%]{font-size:1.5em;margin-block-start:.83em;margin-block-end:.83em;margin-inline-start:0;margin-inline-end:0;font-weight:700}"];
export { styles as styles };
